import { Suspense, useState } from 'react';

import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconAngleRight } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { TopupInEligibleSVG } from '@svgComponents/TopupInEligibleSVG/TopupInEligibleSVG';
import { FormattedMessage } from 'react-intl';

import { useGetNotYetTopUpEligibleData } from './useGetNotYetTopUpEligibleData';
import HelpModal from '../../../navigation/helpModal/HelpModal';
import MainContentPending from '../../../pageStructure/mainContentPending';
import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

export const NotYetTopUpEligible = ({ accountId }: { accountId: string }) => {
    return (
        <Suspense fallback={<MainContentPending />}>
            <NotYetTopUpEligibleContent accountId={accountId} />
        </Suspense>
    );
};

const NotYetTopUpEligibleContent = ({ accountId }: { accountId: string }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { inFirstRepaymentTest, amountToRepayBeforeTopUp } =
        useGetNotYetTopUpEligibleData(accountId);

    return (
        <>
            <DashboardCTA
                data-testid="not-yet-top-up-eligible"
                icon={<TopupInEligibleSVG />}
                title={
                    inFirstRepaymentTest ? (
                        <FormattedMessage
                            id="_.dashboard_widget.notYetTopUpEligible.titleFirstRepayment"
                            defaultMessage="You’re almost there!"
                        />
                    ) : (
                        <FormattedMessage
                            id="_.dashboard_widget.notYetTopUpEligible.title"
                            defaultMessage="You can request more funds once you’ve repaid {amount}"
                            values={{
                                amount: (
                                    <FormattedCurrency
                                        value={amountToRepayBeforeTopUp}
                                    />
                                )
                            }}
                        />
                    )
                }
                description={
                    inFirstRepaymentTest ? (
                        <FormattedMessage
                            id="_.dashboard_widget.notYetTopUpEligible.descriptionFirstRepayment"
                            defaultMessage="You’ll be eligible to request more funds as soon as your first scheduled repayment is processed (usually 30 days after your loan started)."
                        />
                    ) : (
                        <FormattedMessage
                            id="_.dashboard_widget.notYetTopUpEligible.description"
                            defaultMessage="You’ve passed our eligibility checks but your approval will still be subject to a credit review"
                        />
                    )
                }
                cta={
                    <Button
                        variant="tertiary"
                        onClick={() => setIsModalOpen(true)}
                        className="flex-wrap p-0 text-s hover:!bg-transparent hover:underline"
                    >
                        <FormattedMessage
                            id="_.dashboard_widget.notYetTopUpEligible.cta"
                            defaultMessage="Get in touch"
                        />
                        <IconAngleRight />
                    </Button>
                }
            />
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <HelpModal />
            </Modal>
        </>
    );
};
